import React, { Component } from 'react'
import { injectIntl } from 'react-intl';
import { FormattedMessage } from "react-intl";
import $ from 'jquery'


class SavedFilterAlert extends Component {
    constructor(props) {
        super(props);
        this.state = {
            onSaveClicked: props.onSaveClicked || false,
        }
    }

    componentDidUpdate() {
        if (this.state.onSaveClicked !== this.props.onSaveClicked) {
            this.setState({
                onSaveClicked: this.props.onSaveClicked
            })
        }
    }


    render() {
        let savedAlert =
            <a type="button" id="savedFilterAlert" className="text-success small">
                <FormattedMessage
                    id="save_search.saved_text_alert"
                    defaultMessage="Saved!"
                />
            </a>;
        $('#savedFilterAlert').modal('hide').delay(3000).fadeOut();
        return (
            this.state.onSaveClicked ? savedAlert : ''
        );
    }
}

export default injectIntl(SavedFilterAlert);


// WEBPACK FOOTER //
// ./src/common/search-filter/filters-menu/savedFilterAlert.component.jsx